/**
 * Validates if a value is an object.
 */
export function isObject(obj) {
    return obj && typeof obj === 'object' && obj.constructor === Object;
}
/**
 * Verify type of key and return either its matchingKey or itself
 */
export function matching(key) {
    return isObject(key) ? key.matchingKey : key;
}
export function getIsReady(client) {
    return client.__context.get(client.__context.constants.READY, true) ? true : false;
}
export function getIsReadyFromCache(client) {
    return client.__context.get(client.__context.constants.READY_FROM_CACHE, true) ? true : false;
}
export function getIsOperational(client) {
    return getIsReady(client) || getIsReadyFromCache(client);
}
export function getHasTimedout(client) {
    return client.__context.get(client.__context.constants.HAS_TIMEDOUT, true) ? true : false;
}
export function getIsDestroyed(client) {
    return client.__context.get(client.__context.constants.DESTROYED, true) ? true : false;
}
